module.exports = __webpack_public_path__ + "static/media/cbhr_slider_phone1.18940055.png";